import { APPROVAL_LIKELIHOOD } from '@ratehub/documents/loans-journey-document/stable';


function getLoanShape(loan) {
    return !loan
        ? undefined
        : {
            id: loan.ids.primary,
            slug: loan.slug,

            provider: {
                name: loan.provider.name,
                id: loan.provider.ids.primary,
                logo: loan.provider.logo,
            },

            isSecured: loan.secured,

            loanAmountRange: {
                loanAmount: loan.loan_amount.value ?? undefined,
                min: loan.loan_amount.min ?? undefined,
                max: loan.loan_amount.max ?? undefined,
            },
            termRange: {
                term: loan.term.value ?? undefined,
                min: loan.term.min ?? undefined,
                max: loan.term.max ?? undefined,
            },
            aprRange: {
                apr: loan.apr?.value ?? undefined,
                min: loan.apr?.min ?? undefined,
                max: loan.apr?.max ?? undefined,
            },

            expirationDate: loan.expires_at,

            category: loan.category,

            payment: {
                frequency: loan.calculated?.payment?.frequency,
                amount: loan.calculated?.payment?.amount,
            },

            approvalLikelihood: Number.isInteger(loan.approval_likelihood)
                ? API_TO_APPROVAL_LIKELIHOOD[loan.approval_likelihood]
                : APPROVAL_LIKELIHOOD.unknown,

            summaryDetails: loan.description.summary || [],
            disclaimer: loan.description.disclaimer,
            disclaimerAlternate: loan.description.disclaimer_alternate,
            bestUsedFor: loan.description.best_used_for,

            applyURL: loan.urls.apply,
            applyRedirectURL: loan.urls.apply_redirect,

            isMonetized: loan.monetized,
            isSponsored: false, // TODO: will be implemented with https://ratehub.atlassian.net/browse/CCDEP-3945
            // hasReferralOffer has been added before the BE is providing it
            // do not remove it prematurely if you see it is absent from the BE response
            hasReferralOffer: !!loan.referral_offer,
            isHiddenLoanFinder: loan.hidden_loanfinder ?? false,

            ...getOffer(loan.gift_offer),
        };
}

const API_TO_APPROVAL_LIKELIHOOD = [
    APPROVAL_LIKELIHOOD.unknown,        // 0 -> 'unknown'
    APPROVAL_LIKELIHOOD.poor,           // 1 -> 'poor'
    APPROVAL_LIKELIHOOD.fair,           // 2 -> 'fair'
    APPROVAL_LIKELIHOOD.good,           // 3 -> 'good'
    APPROVAL_LIKELIHOOD.approved,       // 4 -> 'approved'
];


/**
 * Get FE giftOffer structure from the API response.
 * At the moment, the Loan response is different from the CC response wrt gift offers.
 * @param {object} giftOffer - arg object
 * @param {number} giftOffer.amount - dollar value of offer
 * @param {string} giftOffer.description - offer description
 * @param {string} giftOffer.expiry_date - offer expiry date as a string
 * @param {string} giftOffer.type - enumeration that describe the offer
 * @param {boolean} giftOffer.is_third_party_fulfilled - true if Ratehub not responsible for fulfilling the offer
 * @returns {import('@ratehub/base-ui').GiftOfferShape | undefined} - the gift offer or undefined
 */
function getOffer(giftOffer) {
    return giftOffer?.description && giftOffer?.amount && giftOffer?.type
        ? {
            giftOffer: {
                promoDetailsHTML: giftOffer.description,
                maxDollarValue: giftOffer.amount,
                offerType: giftOffer.type,
                ...giftOffer?.expiry_date && { expiryDate: new Date(giftOffer.expiry_date) },
                is3rdPartyFulfillment: !!giftOffer.is_third_party_fulfilled,
            },
        }
        : undefined;
}


export default getLoanShape;
